import React from 'react';
import PropTypes from 'prop-types';

import IconPause from './svg/IconPause';

function ButtonPause({ className, style, onClick }) {
  return (
    <div onClick={onClick} className={className} style={{...style}}>
      <IconPause />
    </div>
  )
}

ButtonPause.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
}

export default ButtonPause;
